(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('metricsGeneral', metricsGeneral);

	metricsGeneral.$inject = ['$rootScope', '$scope', '$timeout', 'factorySettingService', 'storeService'];

	function metricsGeneral($rootScope, $scope, $timeout, factorySettingService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		vm.saveSettings = saveSettings;
		vm.dateRange = '';

		init();

		function init() {
			factorySettingService.getFactorySettings(['METRIC_DATE_RANGE'], adminConfig.factory.id)
				.then(function (settings) {
					vm.dateRange = settings.METRIC_DATE_RANGE;
				});
		}

		function saveSettings() {
			factorySettingService.saveFactorySettings({
				METRIC_DATE_RANGE: vm.dateRange
			}, adminConfig.factory.id).then(function (response) {
				if (response === 'Settings saved successfully') {
					$rootScope.$emit('toast', {
						'message': response,
						'success': true
					});
				}
			});
		}
	}
})();
